//请自行添加语言资源
const carrier = {
  carrierCode: '承运商编号',
  carrierName: '承运商名称',
  carrierShortName: '承运商简称',
  companyCode: '机构编码',
  companyName: '机构名称',
  contactMan: '联系人',
  contactTel: '联系电话',
  contactMail: '联系邮箱',
  contactMobile: '联系手机',
  contactAddr: '地址',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',
  useCompanyName: '使用机构',
  msg: {
    carrierCode: '请输入承运商编号',
    carrierName: '请输入承运商编号',
    companyCode: '请选择所属机构',
  }
};
export default carrier



// WEBPACK FOOTER //
// ./src/page/mdm/carrier/lang/carrier.zh.js